import React, { Component } from 'react';
import {Link} from "react-router";
import Utils from "../../../Utils/Utility";

export default class NavigationMenu extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };


    constructor(props) {
        super(props);

        this.state = {
            activeLocation : null

        };
        //
        // this.openNav  = this.openNav.bind(this);
        // this.closeNav = this.closeNav.bind(this);
    }

    componentDidMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        });

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        });
    }

    componentWillReceiveProps(nextProps) {

        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if (currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if (nextProps !== null
            &&
            nextProps.activeLocation !== null
            &&
            nextProps.activeLocation.objectId !== locId
        ) {
            this.setState({
                activeLocation: nextProps.activeLocation,

            });
        }
    }

    render() {
        let locationName     = "";
        const activeLocation = this.state.activeLocation;
        let locationAddress = Utils.getAddressStrFromLocation( activeLocation );

        // Check the active location object
        if(activeLocation){
            // get the location name
            locationName = activeLocation.name
        }

        return (

            <nav id="sidebar">
                <div className="sidebar-header">
                    <h3>{locationName}</h3>
                    <p className="list-group-item-text rst-address" >{locationAddress}</p>
                    <a
                        href      = "JavaScript:void(0);"
                        className = "btn btn-link btn-danger"
                        role      = "button"
                        onClick   = {this.props.callBack}
                        className="download">Switch Location</a>
                </div>

                <ul className="list-unstyled components">
                    <li>
                        {/*<a href="#"><i className="fa fa-fw fa-home"/>Dashboard</a>*/}
                        <Link to="/dashboard"><i className="fa fa-fw fa-home"/>Dashboard</Link>
                    </li>
                    <li>
                        <a href="#"><i className="fa fa-fw fa-table"/>Orders</a>
                    </li>
                    <li>
                        <a href="#"><i className="fa fa-fw fa-users"/>Customers</a>
                    </li>
                    <li>
                        <a href="#analyticsMenu" data-toggle="collapse"
                           aria-expanded="false"><i className="fa fa-fw fa-bar-chart"/>Analytics</a>
                        <ul className="collapse list-unstyled" id="analyticsMenu">
                            <li><a href="#">Sales Trend</a></li>
                            <li><a href="#">Popular Items</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="#"><i className="fa fa-fw fa-clipboard"/>Billing</a>
                    </li>
                    <li>
                        {/*<a href="/logout" ><i className="fa fa-fw fa-sign-out"/>Logout</a>*/}
                        <Link to="/logout"><i className="fa fa-fw fa-sign-out"/>Logout</Link>
                    </li>
                </ul>
            </nav>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/sidebar/navigation-menu.js